import * as multiparty from 'multiparty';
import * as fnFn from 'fs';
import * as http from 'http';
export interface File {
	// 文件名称
	readonly name: string;
	// 原始名称
	readonly filename: string;
	// 文件大小
	readonly size: number;
	// 文件类型
	readonly mime: string;
	// 文件临时路径
	readonly path: string;
	// 获取文件二进制信息
	getBuffer(): Promise<Buffer | null>;
	// 获取文件输入流
	getReadStream(options?: string | {
		flags?: string;
		encoding?: string;
		fd?: number;
		mode?: number;
		autoClose?: boolean;
		start?: number;
		end?: number;
		highWaterMark?: number;
	}): fnFn.ReadStream | null;
	// 销毁文件
	destroy(): void;
	// 保存文件
	getUrl(...p: any[]): Promise<string>;
	// 保存文件并获取保存路径
	save(...p: any[]): Promise<string>;
	// 保存文件并获取URL
	getPath(...p: any[]): Promise<string>;
}

export interface saveFile{
	 (file: File, ...any: any[]): string | Promise<string>;
}
export interface getUrl{
	(f: string): string | Promise<string>;
}
export interface getPath{
	(f: string): string | Promise<string>;
}
/**
 * @param  {Object}	原始信息
 * @return {FileInfo}	文件信息
 */
function createFile(info,  saveFile: saveFile, getUrl: getUrl, getPath: getPath ): File {
	//字段名称，文件名，临时存储路径，文件大小，文件类型
	const name = info.fieldName,
		filename = info.originalFilename,
		path = info.path,
		size = info.size,
		mime = info.headers && info.headers['content-type'] || '';
	//是否已销毁
	let destroy = false;

	let save: string | Promise<string>;

	const file: File = {
		//获取字段名称
		get name() { return destroy ? '' : name; },
		//获取原始文件名
		get filename() { return destroy ? '' : filename; },
		//获取文件尺寸
		get size() { return destroy ? 0 : size; },
		//获取文件类型
		get mime() { return destroy ? '' : mime; },
		//获取文件临时路径
		get path() { return destroy ? '' : path; },
		//获取文件二进制信息
		async getBuffer() { return destroy ? null : new Promise((a, b) => fnFn.readFile(path, (e, d)=> e ? b(e) : a(d))); },
		//获取文件输入流
		getReadStream(options?: string | {
			flags?: string;
			encoding?: string;
			fd?: number;
			mode?: number;
			autoClose?: boolean;
			start?: number;
			end?: number;
			highWaterMark?: number;
		}) { return destroy ? null : fnFn.createReadStream(path, options); },
		//销毁文件
		destroy() {
			if (destroy) { return; }
			destroy = true;
			fnFn.unlink(path, e => e);
		},
		async save(...p): Promise<string> {
			if (save || typeof save === 'string') { return save; }
			if (destroy) { return ''; }
			return save = saveFile(this, ...p);
		},
		async getUrl(...p): Promise<string> { return destroy ? '' : getUrl(await file.save(...p)); },
		async getPath(...p): Promise<string> { return destroy ? '' : getPath(await file.save(...p)); },
	}
	return file;
}

function getFileList(files, saveFile: saveFile, getUrl: getUrl, getPath: getPath): File[] {
	const list: File[] = [];
	for (let k in files) {
		files[k].forEach(file => list.push(createFile(file, saveFile, getUrl, getPath)));
	}
	return list;
}

function getBody(fields) {
	const data = {};
	for (let k in fields) {
		const d = fields[k];
		data[k] = d.length === 1 ? d[0] : d;
	}
	return data;
}

/**
 * 获取请求文件
 */
export default async function multipart( IncomingMessage: http.IncomingMessage, saveFile: saveFile, getUrl: getUrl, getPath: getPath ): Promise<[object, File[]]> {
	return new Promise(next => new multiparty.Form().parse(IncomingMessage, function(err, fields, files) {
		if (err) { return next([{}, []]); }
		return next([getBody(fields), getFileList(files, saveFile, getUrl, getPath)]);
	}));
}
